module.exports = __webpack_public_path__ + "img/Ardunic Elements-171.47ae3d5a.svg";